<template>
  <div>
    <div class="w-100 mb-0 text-center">
      <span class="qualification">
        <img :src="qualification" class="image" />
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component
export default class QualificationImage extends Vue {
  @Prop({
    type: String,
    default: null
  })
  imageUrl!: string | null;

  get qualification() {
    return (
      this.imageUrl ??
      require("@/assets/img/register/DefaultQualificationIcon.png")
    );
  }
}
</script>

<style lang="scss" scoped>
.qualification {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 80px;
  overflow: hidden;

  .image {
    width: 120px;
    height: 80px;
    object-fit: contain;
  }
}
</style>
